<template>
  <div class="main">
    <div class='banner'>
      <img src="https://static.medsci.cn/public-image/ms-image/b6beffa0-0cfa-11eb-9636-cbbf4af7868c_banner.png" alt="">
    </div>
    <div class="content">
      <!-- 导语模块 -->
      <div class="daoyu">
         <div class="daoyu_top">
            <h2>导语</h2>
            <i></i>
         </div>
         <div class="daoyu_botm">
            <span>
              2020年是一个让所有人都措手不及的年份，“病毒”一词频频出现在人们的视野中，从美国新型流感大爆发、全球新冠疫情肆虐，非洲埃博拉疫情再次出现，到此起彼伏的禽流感、猪瘟疫情。人类与病毒的斗争似乎已进入白热化阶段。随着科学技术的发展，研究人员不断开发和应用最新科技手段对病毒及其相关领域进行研究，寻找攻克病毒的方法。<br/>
              <span style="display:block;text-indent: 2em;"> Fluidigm一直以来致力于生命科学领域新技术、新仪器的研究和开发。拥有微流控和质谱流式等多项核心技术，覆盖基因、蛋白和细胞水平的诸多研究领域。让我们从多组学角度与您共同探讨病毒研究领域的整体解决方案。</span>
            </span>
         </div>
      </div>
        <!-- 人物专访 -->
      <div class="person pubcss">
         <div class="person_top pubcss_top">
           <img class='person_top_img pubcss_top_img' src="../assets/hh/tapic1.png" alt="">
           <span>人物专访</span>
           <i class="line"></i>
           <div class="clear" style="clear:both;"></div>
         </div>
         <div class="person_botm">
           <p class="person_botm_left">
             <img src="../assets/renwu.png" alt="">
           </p>
           <p class="person_botm_right">
             陈德喜，教授，研究员。北京大学医学院生物化学与分子生物学博士学位，现任北京市肝病研究所常务副所长，并曾多次赴美参与神经及肿瘤相关研究交流。2020年新冠疫情突发的紧急关口，陈教授带领的科研团队始终奋战在第一线，迅速调配科研资源进行相关的研究，并获得多项世界领先的研究成果，为抗击疫情做出了重大贡献。
             <span class="liaoPlus" @click="linkUrl('https://www.fluidigm.com/spotlights?changeLanguage=true#d3d75568-883e-461c-ac14-b5fe68be3083')">了解详情</span>
           </p>
         </div>
      </div>
      <!-- 质谱流式 -->
      <div class="zhipu pubcss">
        <div class="person_top pubcss_top">
           <img class='person_top_img pubcss_top_img' src="../assets/hh/tapic2.png" alt="">
           <span>质谱流式与病毒研究</span>
           <i class="line"></i>
           <div class="clear" style="clear:both;"></div>
        </div>
        <div class="zhipu_botm">
          <div class="item" v-for="item in duList" :key='item.id' @click="linkUrl(item.url,item.id)">
            <img :src="'http://7n.m-visitor.medsci.cn/lfd/'+item.image_url" alt="">
            <h3>{{item.title}}</h3>
            <div>
               {{item.desc}}<span class="liaoPlus">了解详情</span>
            </div>
            
            
            <!-- <div>{{item.description}}</div> -->
          </div>
        </div>
      </div>
      <!-- 流控技术 -->
      <div class="liukong pubcss">
        <div class="person_top pubcss_top">
           <img class='person_top_img pubcss_top_img' src="../assets/hh/tapic3.png" alt="">
           <span>微流控技术与病毒检测</span>
           <i class="line"></i>
           <div class="clear" style="clear:both;"></div>
        </div>
        <div class="liukong_botm">
            <div style="text-indent:2em;">
              Fluidigm独有的微流控芯片技术, 全封闭独立的qPCR反应仓特点使得多样本、多目标的自动化快速检测成为可能，能够在较短时间内准确甄别致病病原体、相似症状的病原体差异等，助力公共卫生系统迅速建立有效预警方案。同时系统配套的实时dPCR微流控芯片可以对低病毒载量样本进行准确定量，提高检测灵敏度。另外，系统还可实现NGS文库制备功能，自动化构建病原菌NGS文库。Fluidigm 高通量、多功能微流控技术带来以极小量样本获得大数据的优势，特别适合用有限的病人样本研究病毒毒力因子导致的复杂的宿主免疫系统变化，有助于明确新型冠状病毒的致病机理，鉴别出易感人群的特征。
            </div>
            <div class="bott">
                <div class="bott_top">                 
                  <span>相关资讯</span>
                  <i class="line"></i>
                </div>
                <div class="bott_botm">
                  <p v-for="item in ziXunList" :key='item.id' @click="linkUrl(item.url,item.id)">
                    <img src="../assets/pc/road.png" alt=""><span>{{item.title}}</span>
                  </p>                 
                </div>
            </div>
        </div>
      </div>
      <!-- 信息资源 -->
      <div class="info pubcss">
        <div class="person_top pubcss_top">
           <img class='person_top_img pubcss_top_img' src="../assets/hh/tapic4.png" alt="">
           <span>信息资源</span>
           <i class="line"></i>
           <div class="clear" style="clear:both;"></div>
        </div>
        <div class="info_botm">
            <div class="info_botm_one info_public">
                <div class="public_top">
                  <img class='info_icon' src="../assets/hh/jiangzuo.png" alt=""><span class="hh">在线讲座：</span>
                </div>
                <div class="tpp"  v-for="item in jiangzuoList" :key='item.id' @click="linkUrl(item.url,item.id)">
                  <img src="../assets/pc/road.png" alt=""><div>{{item.title}}</div>
                </div>               
            </div>
            <div class="info_botm_one info_public" style="margin-top:0.15rem;">
              <div class="public_top">
                <img class='info_icon' src="../assets/pc/wenxian.png" alt=""><span class="hh">文献解读：</span>
              </div>
              <div class="tpp" v-for="item in wenxianList" :key='item.id' @click="linkUrl(item.url,item.id)">
                <img src="../assets/pc/road.png" alt=""><div>{{item.title}}</div>
              </div>              
            </div>
            <div class="info_botm_one info_public public_special" style="margin-top:15px;">
              <div class="public_top">
                <img class='info_icon' src="../assets/pc/download.png" alt=""><span class="hh">资料下载：</span>
              </div>
              <div class="tpp" v-for="(item,index) in downList" :key='item.id'>
                <img src="../assets/pc/road.png" alt=""><div>{{item.title}}<i  @click="getDio(item.id,index)">下载</i></div>
              </div>              
            </div>
        </div>
      </div>
      <!-- Fluidigm -->
      <div class="fluidigm pubcss">
         <div class="fluidigm_top pubcss_top">
           <img class='person_top_img pubcss_top_img' src="../assets/pc/tapic5.png" alt="">
           <span>Fluidigm整体解决方案</span>
           <i class="line"></i>
           <div class="clear" style="clear:both;"></div>
         </div>
         <div class="fluidigm_botm">
          <div class="item" v-for="item in fluidList" :key='item.id'  @click="linkUrl(item.url,item.id)">
             <img :src="'http://7n.m-visitor.medsci.cn/lfd/'+item.image_url" alt="">
             <span>{{item.title}}</span>
          </div>
         </div>
      </div>
      <!-- hudong -->
      <div class="hudong pubcss">
        <div class="person_top pubcss_top">
           <img class='person_top_img pubcss_top_img' src="../assets/hh/tapic6.png" alt="">
           <span>有奖互动</span>
           <i class="line"></i>
           <div class="clear" style="clear:both;"></div>
        </div>
        <div class="hudong_botm">
            <div style="color: #666666;font-size:0.24rem;margin-bottom:10px;text-indent:2em;">
             感谢您对Fluidigm公司及产品的关注。请您花费几分钟时间参与本次问卷调查，您的信息经Fluidigm确认后，即可获得精美礼品一份。您的意见和建议对我们很重要，谢谢您的支持！本次有奖调研活动截止日期为2021年12月30日。 Fluidigm公司对本次活动保留最终解释权。
            </div>
           <div class="form">
              <div class="from_public">
                <label><i style="color:red;">*</i>您的姓名：</label>
                <input v-model="form.name" placeholder="填入姓名" :class="is_name?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public">
                <label><i style="color:red;">*</i>您的工作单位：</label>
                <input v-model="form.placework" placeholder="填入单位" :class="is_placework?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public">
                <label><i style="color:red;">*</i>您的部门：</label>
                <input v-model="form.department" placeholder="填入部门" :class="is_department?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public">
                <label><i style="color:red;">*</i>您的职务：</label>
                <input v-model="form.duties" placeholder="填入职务"  :class="is_duties?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public">
                <label><i style="color:red;">*</i>您的手机/电话：</label>
                <input v-model="form.mobile" placeholder="填入手机/电话"  @blur="onChange" :class="is_mobile?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public">
                <label><i style="color:red;">*</i>您的Email：</label>
                <input v-model="form.email" @blur="onEmail" placeholder="填入Email" :class="is_email?'place-actived':''" type="text" class="normal"/>
              </div>
           </div>
           <div class="special_line"></div>
            <div class="question" v-for="item in questionList" :key='item.id'>
              <i style="color:red;" v-if="item.required">*</i> <span>{{item.sn}}</span> <span>|</span> <span>{{item.title}}</span>
              <div class="option clearfix">
                  <van-radio-group v-if="item.type==1" direction="horizontal" v-model="radio[item.sn]" v-for="it in item.option" :key='it.option' @change="getRadio">
                    <van-radio :name="it.value" :class="it.value=='其他：'?'moreOther':'radio'" icon-size="0.32rem" >{{it.value}}</van-radio>  
                    <input v-if="item.is_other==1&&it.value=='其他：'"  :disabled="radio[item.sn]=='其他：'?false:true"  type="text" class="inp" v-model="item.other_value" />                 
                  </van-radio-group>                  
                  <van-checkbox-group v-if="item.type==2"  v-model="checkList" v-for="it in item.option" :key='it.option' @change="handleCheckedCitiesChange(item.sn,it.value)">
                    <van-checkbox icon-size="0.32rem"  shape="square"  :class="it.value=='其他：'?'moreOther':'radio'"   :name="item.sn+','+ it.value" >{{it.value}}</van-checkbox>
                    <input v-if="item.is_other==1&&it.value=='其他：'" :disabled="checkList.indexOf('2,其他：')!==-1?false:true"   type="text" class="inp" v-model="item.other_value" />
                  </van-checkbox-group>
                  <textarea rows="4"  style="width:90%;"
                      v-if="item.type==3"
                      v-model="idea"                      
                      autosize                   
                      type="textarea"
                      maxlength="200"                 
                      show-word-limit
                    />
              </div>
            </div>          
        </div>
        <van-button type="info" size='small' @click="onSubmit">提交</van-button>
      </div>
      <!-- lianxi -->
      <div class="lianxi pubcss">
          <div class="fluidigm_top pubcss_top">
              <img class='person_top_img pubcss_top_img' src="../assets/pc/tapic7.png" alt="">
              <span>联系我们</span>
              <i class="line"></i>
              <div class="clear" style="clear:both;"></div>
          </div>
          <div class="lianxi_botm">
            <div class="lianxi_top">
             <h2>富鲁达（上海）仪器科技有限公司</h2>
             <div>
               地址： 上海市中山西路1600号宏汇国际广场A座1709室
             </div>
             <div>
               电话： 021-32558368
             </div>
             <div>
               Email：info-china@fluidigm.com
             </div>
             <div @click="linkUrl('https://www.fluidigm.com.cn')">
               网址： www.fluidigm.com.cn
             </div>
            </div>
            <div class="lianxi_bottom">
              <img src="../assets/hh/erwei.png" alt="">
              <div>
                Fluidigm中国官方微信公众号
              </div>
            </div>
          </div>
      </div>
    </div>
    <van-dialog v-model="show"   :before-close="beforeClose" show-cancel-button width='90%' style="overflow-y:scroll;" @confirm='confirm'>
        <div class="form" style="height:100%;padding-left:0.05rem;padding-right:0.1rem;">
              <div class="from_public pphh" style="margin-top:0.2rem;">
                <label><i style="color:red;">*</i>您的姓名：</label>
                <input v-model="form.name" placeholder="填入姓名" :class="is_name?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public pphh">
                <label><i style="color:red;">*</i>您的工作单位：</label>
                <input v-model="form.placework" placeholder="填入单位" :class="is_placework?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public pphh">
                <label><i style="color:red;">*</i>您的部门：</label>
                <input v-model="form.department" placeholder="填入部门" :class="is_department?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public pphh">
                <label><i style="color:red;">*</i>您的职务：</label>
                <input v-model="form.duties" placeholder="填入职务"  :class="is_duties?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public pphh">
                <label><i style="color:red;">*</i>您的手机/电话：</label>
                <input v-model="form.mobile" placeholder="填入手机/电话"  @blur="onChange" :class="is_mobile?'place-actived':''" type="text" class="normal"/>
              </div>
              <div class="from_public pphh">
                <label><i style="color:red;">*</i>您的Email：</label>
                <input v-model="form.email" @blur="onEmail" placeholder="填入Email" :class="is_email?'place-actived':''" type="text" class="normal"/>
              </div>
        </div>
    </van-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return  {      
      form:{
         name:'',
         mobile:'',
         duties:'',
         placework:'',
         department:'',
         email:''
       },
        worktype:'',
       researcharea:'',
       isbuy:'',
       buyplan:'',
       istouch:'',
       idea:'',
       acceptinfo:'',
       radio:[],
       checkList:[],
       idea:'',
       questionList:[
         {id:1,sn:1,title:'您的工作性质:',type:'1',is_other:1,required:1,other_value:'',option:[{
           option:"A",value:'基础科研'
         },{ option:"B",value:'临床科研'},{ option:"C",value:'分析服务中心'},{ option:"D",value:'其他：'}
         ]},
         {
           id:2,sn:2,title:'您的主要研究领域（多选）:',type:'2',is_other:1,required:1,other_value:'',option:[
             {option:'A',value:'传染病研究'},{option:'B',value:'神经细胞生物学'},{option:'C',value:'免疫学研究'},{option:'D',value:'干细胞研究'},
             {option:'E',value:'药物机制研究'},{option:'F',value:'其他：'}
           ]
         },
         {
           id:3,sn:3,title:'您是否已购Fluidigm仪器?',type:'1',required:1,option:[
             {option:'A',value:'是'},{option:'B',value:'否'}
           ]
         },
         {
           id:4,sn:4,title:'您近期是否有采购计划*',type:'1',required:1,option:[
             {option:'A',value:'是'},{option:'B',value:'否'}
           ]
         },
         {
           id:5,sn:5,title:'您是否希望Fluidigm工作人员联系您以获取技术咨询或产品报价？',type:'1',required:1,option:[
             {option:'A',value:'是'},{option:'B',value:'否'}
           ]
         },
         {
           id:6,sn:6,title:'您对我公司的产品和服务有何意见和建议？：',type:'3',required:1,value:''
         },
         {
           id:7,sn:7,title:'您是否愿意通过电话、电子邮件或其他电子方式接收Fluidigm产品和服务的信息？',type:'1',required:1,option:[
            {option:'A',value:'是'},{option:'B',value:'否'}
           ]
         }
       ],
       is_name:false,
       is_mobile:false,
       is_duties:false,
       is_placework:false,
       is_department:false,
       is_email:false ,
       downList:[],
       wenxianList:[],
       jiangzuoList:[],
       ziXunList:[],
       duList:[],
       fluidList:[],
       articleid:'',
       art_token:'',
       uid:'',
       show: false
           
    }
  },
  created(){
    this.getList(1)  
    this.getList(2) 
    this.getList(3)
    this.getList(4)
    this.getList(5)
    this.getList(6)
  },
  methods: {
     onChange(){
      if(!(/^1[3456789]\d{9}$/.test(this.form.mobile))){ 
        this.$toast('手机号格式不正确')
        return false; 
      }
    },
    onEmail(){
      if(!(/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(this.form.email))){ 
        this.$toast("邮箱格式有误，请重填");  
        return false; 
      }
    },
    getRadio(){     
      for(var i in this.radio){
        if(i==1){
          if(this.radio[i]!=='其他：'){
            this.questionList[0].other_value = ''
          }
        }
      }
    },
    handleCheckedCitiesChange(sn,value){     
      if(this.checkList.indexOf(sn+','+value)==-1&&value=='其他：'){
        this.questionList[1].other_value = ''
      }
    },
    // 获取文章列表
    getList(type){
      this.api.getList(type).then(res=>{     
        if(res.code==200) {
          if(type==4){
            this.wenxianList = res.result
          }else if(type==3){
            this.jiangzuoList = res.result
          }else if(type==5){
            this.downList = res.result
          }else if(type==2){
            this.ziXunList = res.result
          }else if(type==1){
            this.duList = res.result
          }else if(type==6){
            this.fluidList = res.result
          }
        }else {
          this.$message.error(res.msg)
        }
      })
    },
    onSubmit(){
      if(!this.form.name) {
         this.is_name = true
         return;
      }      
      if(!this.form.placework) {
         this.is_placework = true
         return;
      }
      if(!this.form.department) {
         this.is_department = true
         return;
      }
      if(!this.form.duties) {
         this.is_duties = true
         return;
      }
      if(!this.form.mobile) {
         this.is_mobile = true
         return;
      }
      if(!this.form.email) {
         this.is_email = true
         return;
      }
      this.researcharea = ''
      let other = ''
      for(var i in this.radio){        
         if(i==1){
           if(this.questionList[0].other_value){
              this.worktype = this.radio[i] + this.questionList[0].other_value
           }else{
             this.worktype = this.radio[i]
           }
         }else if(i==3){
           this.isbuy = this.radio[i]
         }else if(i==4) {
           this.buyplan = this.radio[i]
         }else if(i==5){
           this.istouch = this.radio[i]
         }else if(i==7){
           this.acceptinfo = this.radio[i]
         }
         
       }
      for(var j in this.checkList){              
        let arr = this.checkList[j].split(',')     
        if(this.questionList[1].other_value){
            other = '其他：'+ this.questionList[1].other_value 
        }
        if(arr[1]!=='其他：'){
         this.researcharea = arr[1] + ',' + this.researcharea 
        }
      }
      this.researcharea = this.researcharea + other
      if(!this.worktype) {
        this.$toast('请选择您的工作性质')
        return false
      }  
      if(!this.researcharea) {
        this.$toast('请选择您的研究领域')       
        return false
      }   
      if(!this.isbuy) {
        this.$toast('请选择您是否购买过产品')  
        return false
      } 
      if(!this.buyplan) {
        this.$toast('请选择您是否有购买意愿')         
        return false
      }   
      if(!this.istouch){
        this.$toast('请选择您是否希望联系')  
        return false
      }
      if(!this.idea) {
        this.$toast('请填写意见和建议')  
        return false
      } 
      if(!this.acceptinfo){
        this.$toast('请选择您是否接收信息')  
        return false
      }
      if(!(/^1[3456789]\d{9}$/.test(this.form.mobile))){ 
        this.$toast('手机号格式不正确')
        return false; 
      }
      if(!(/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(this.form.email))){ 
        this.$toast("邮箱格式有误，请重填");  
        return false; 
      }
      //  console.log(this.researcharea,'this.researcharea',other)
      const params = {
          ...this.form,
          worktype:this.worktype,
          researcharea:this.researcharea,
          isbuy:this.isbuy,
          buyplan:this.buyplan,
          istouch:this.istouch,
          idea:this.idea,
          acceptinfo:this.acceptinfo,
      }
      this.postSubmit(params)
   
    },
    // 提交表单
    postSubmit(param){
      this.api.postSubmit(param).then(res=>{
        console.log(res)
        if(res.code==200){
            this.$toast('提交成功')
        }
      })
    },
    // 点击下载弹框
    getDio(id,index) {      
      if(index==3){
        window.location.href = 'https://www.fluidigm.com.cn/index.php?m=content&c=index&a=lists&catid=14'
      }else{
          if(window.localStorage.getItem('art-token')){
            // console.log(11)
            // this.art_token = JSON.parse(window.localStorage.getItem('art-token'))
            // this.uid= JSON.parse(window.localStorage.getItem('art-uid'))
            this.linkDownCom(id)    
            return
          }
          this.articleid = id
          this.show = true  
          this.form = {}        
      }
    },
     // 跳转下载链接
    linkDownCom(id){
      this.api.linkDownCom(id).then(res=>{
        if(res.code==200) {
          window.location.href = res.result.url
        }
      })
    },
    // 
    beforeClose : function (action, done) { // 点击事件 - 备注按钮提示框
        if (action === 'confirm') { // 确认
          console.log('[点击事件 - 备注] - 确认');
          done(false); // 关闭提示框
        } else if (action === 'cancel') { // 取消
          console.log('[点击事件 - 备注] - 取消');
          done(); // 关闭提示框
        }
    },
    // 点击弹框
    confirm(){
      if(!this.form.name) {
         this.is_name = true
         return;
      }      
      if(!this.form.placework) {
         this.is_placework = true
         return;
      }
      if(!this.form.department) {
         this.is_department = true
         return;
      }
      if(!this.form.duties) {
         this.is_duties = true
         return;
      }
      if(!this.form.mobile) {
         this.is_mobile = true
         return;
      }
      if(!this.form.email) {
         this.is_email = true
         return;
      }
      const params = {
            ...this.form,
            articleid:this.articleid
          }
      this.downLoad(params)
      
    },
    downLoad(param){
      this.api.downLoad(param).then(res=>{
        if(res.code==200){
          this.show = false      
          window.localStorage.setItem('art-token',JSON.stringify(res.result.token))
          window.localStorage.setItem('art-uid',JSON.stringify(res.result.uid))       
        }else {
          this.$toast(res.msg)
        }
      })
    },
    //链接
    linkUrl(url,id) {
      if(id){
        this.lookReadNum(id)
      }
      if(url) {
         window.location.href = url
      }
    },
     // 查看访问量
    lookReadNum(id){
      const param= {
        articleid:id
      }
      this.api.lookReadNum(param).then(res=>{
        if(res.code==200) {
          // console.log(res)
        }else {
          this.$message.error(res.msg)
        }
      })
    }   
  }
}
</script>
<style lang="scss" scoped>
  .clearfix::after{
    content: '';
    display: block;
    line-height: 0;
    clear: both;   
  }
  .main {
    height: 100%;
    background: #f7f7f7;
    .banner {
      height: 3.2rem;
      img {    
         width: 100%;  
        height: 100%;
        vertical-align: middle;
      }
    }
    .content {
      padding:0 0.21rem 0.2rem 0.23rem;
      .daoyu {
        margin-top:0.25rem;            
        border-radius: 0.1rem;
        background: linear-gradient(#e6f4fc, #fdfefe);
        box-shadow: 0px 2px 0.03rem 0px rgba(0,0,0,0.16); 
        padding: 0.3rem 0.26rem 0.46rem 0.32rem;
        .daoyu_top {
          font-size: 0.3rem;
          color: #0073A4;
        }
        i {
          display: inline-block;
          width: 100%;
          height: 3px;
          background: linear-gradient(to right,#1b9adc, #edf7fc);
          margin-top: 0.2rem;
          margin-bottom: 0.22rem;
        }
        .daoyu_botm {
          font-size: 0.24rem;
          color: #666666;
          text-indent: 2em;
        }
      }
      .pubcss {          
        background: #ffffff;
        border-radius: 0.1rem;
        padding: 0px 0.14rem 0.17rem 0.22rem;
        box-sizing: border-box;
        margin-top:0.2rem;
        position: relative;
        .pubcss_top {
          padding-left: 1.23rem;
          padding-top: 0.15rem;
          span {
              font-size: 0.28rem;
              font-family: Microsoft YaHei, Microsoft YaHei-Bold;
              font-weight: 700;
              text-align: left;
              float: left;
              color: #006aab;
            }
            i {
              display: inline-block;
              width: 100%;
              height: 1px;
              float: left;
              margin:0.19rem 0 0.24rem 0;
              border-bottom: 1px dashed #008dcd;
            }
            .pubcss_top_img {
              position: absolute;
              top:0;
              left: 0;
              width: 1.39rem;
              height: 0.84rem;
              vertical-align: middle;
            }
        }
        .person_botm {
            // margin-top:0.15rem;
            display: flex;
            justify-content: flex-start;
          .person_botm_left {
            width: 0.86rem;
            height: 0.86rem;         
            margin-right: 0.43rem;
            // background: #b0daf0;
            img {
              width: 100%;
              height: 100%;
              vertical-align: middle;
            }
          }
          .person_botm_right {
            width: 90%;
            font-size: 0.24rem;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #666666;
          }
        }

      }
      .zhipu {
        .zhipu_botm {
          .item {
            padding:0.36rem 0 0.35rem 0;
            border-bottom: 1px dashed #d3d3d3;
          }
          img {
            width: 100%;
            height: 4.37rem;
            vertical-align: middle;
          }
          h3 {
            font-size: 0.28rem;
            font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
            font-weight: 600;
            text-align: left;
            color: #333333;
            margin:0.2rem 0 0.2rem 0;
          }
          div {
            font-size:0.24rem;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #666666;
           
          }
        }
      }
      .liukong {
        .liukong_botm {
          font-size: 0.24rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
          .bott_top {
            margin-top:0.41rem;
            span {
              font-size:0.28rem;
              font-family: Microsoft YaHei, Microsoft YaHei-Bold;
              font-weight: 700;
              text-align: left;
              color: #006aab;
            }
            i {
              display: inline-block;
              width: 100%;
              height: 1px;
              border-bottom: 1px dashed #008dcd;
            }
          }
          .bott_botm {
              margin-top:0.31rem;
              p {
                margin-bottom: 0.1rem;
                img {
                  width: 0.2rem;
                  height: 0.2rem;
                  vertical-align: middle;
                  margin-right: 0.21rem;
                }
                span {
                  width:90%;
                  display: inline-block;
                   vertical-align: top;
                  color: #666666;
                  font-size: 0.24rem;
                }
              }
            }
        }
      }
      .info {       
        .info_botm {
          // margin-top:0.12rem;
          .info_public {
             position: relative;
             padding-top:0.6rem;
              .public_top {
                  position: absolute;
                  top:-0.5rem;
                  left: 0;
                // margin-bottom:0.13rem;                
              }
              .info_icon {
                width: 0.29rem;
                height:0.35rem;
                margin-right: 3px;
                vertical-align: middle;
              }
              .hh {
                font-weight: 600;
                color: #333;
                font-size:0.24rem;
                vertical-align: middle;
              }
             .tpp {
               img {
                  width: 0.2rem;
                  height: 0.2rem;
                  vertical-align: middle;
                  margin-right:0.21rem;
                  
                }
                margin-bottom: 10px;
                font-size: 0.24rem;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: left;
                color: #666666; 
                div {
                 display: inline-block;
                 width: 90%;
                 vertical-align: top;
                }
              }
          }
          .info_botm_one {
            border-bottom: 1px dashed #d3d3d3 ;
          }
          .public_special {
            border-bottom:0 none;
            .tpp i {
              margin-left: 5px;
              display: inline-block;
              // width: 0.77rem;
              // height: 0.32rem;
              // line-height: 0.32rem;
              padding:0.05rem 0.2rem;
              text-align: center;
              background: #0081c1;
              border-radius: 10px;
              color: #fff;
              font-size: 0.2rem;
            }
            }  
        }
      }
      .fluidigm {
        .fluidigm_botm {
            margin-top:0.12rem;
            display: flex;
            flex-wrap: wrap;
            .item {
              width: 50%;
              padding:0.2rem;
              box-sizing: border-box;
              margin-bottom: 0.25rem;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              img {
                // width: 1.2rem;
                // height: 1.48rem;
                vertical-align: middle;
                margin-bottom: 0.2rem;
              }
              span {
                font-size: 0.24rem;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: left;
                color: #666666;
              }
            }
        }
      }
      .hudong {
        .hudong_botm {          
          .from_public {
            font-size: 0.28rem;
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.24rem;
            label {
              margin-top:0.2rem;
              font-size: 0.24rem;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: left;
              color: #666;
            }
            input {
              -webkit-appearance: none;
              border: 0 none;
              width: 4.27rem;
              height: 0.6rem;
              padding-left: 0.2rem;
              border: 1px solid #c6c6c6;
              border-radius: 3px;
              &::-webkit-input-placeholder {
                font-size: 0.24rem;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: left;
                color: #c2c2c2;
             }
            }
            
          }
          .place-actived::-webkit-input-placeholder {
                color: red!important;
                font-size: 25px;
          }
          .special_line {
            width: 100%;        
            border-bottom: 1px dashed #d3d3d3;
            margin-bottom: 0.17rem;
          }
          .question {
              font-size: 0.24rem;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: left;
              color: #666;
              margin-bottom: 0.18rem;
              .option {
                margin-top:0.15rem;
                padding-left: 0.1rem;
                .radio {
                  margin-bottom: 0.2rem;
                }
                .moreOther {
                    // width: 22%;
                    float: left;
                    margin-bottom: 0.24rem;
                    color: #727272;
                }
                .inp {
                    -webkit-appearance: none;
                    border: 0 none;
                    display: inline-block;
                    height: 0.45rem;
                    border: 1px solid #c6c6c6;
                    border-radius: 3px;
                }
              }
            }
        }
      }
      .lianxi {
        .lianxi_botm h2{
          font-size: 0.24rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
          font-weight: 600;
          text-align: left;
          color: #333333;
        }
         .lianxi_botm div{
          font-size: 0.24rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Semibold;
          font-weight: 400;
          text-align: left;
          color: #666;
          margin:0.31rem 0;
        }
        .lianxi_bottom {          
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          div {
            margin: 0;
          }
          img {
            widows: 3.39rem;
            height: 3.39rem;
            vertical-align: middle;
          }
        }
      }
      textarea{
        resize:none;  //不允许用户调整元素大小
        -webkit-appearance: none;
        border: 0 none;
        border: 1px solid #c6c6c6;
      }
    }
    .place-actived::-webkit-input-placeholder {
        color: red!important;
        font-size: 0.25rem;
    }
    .pphh {
      margin:0.3rem 0;
      display: flex;
      justify-content: space-between;
      input {
        -webkit-appearance: none;
        border: 0 none;
        width: 3rem;
        height: 0.6rem;
        padding-left: 0.2rem;
        border: 1px solid #c6c6c6;
        border-radius: 3px;
        &::-webkit-input-placeholder {
          font-size: 0.24rem;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #c2c2c2;
        }
      }
    }
  }
  .liaoPlus {
    color:#1b9adc!important;cursor: pointer;
  }
</style>
<style>
  .van-radio--horizontal {
    margin-right: 0;
  }
  .van-dialog__content {
    /* height: 80%; */
  }
</style>